export default {
    current_choice: 'Obecny wybór',
    book_now: 'Zarezerwuj teraz',
    minimum_age: 'Tylko dla osób powyżej {age} lat',
    excess_liability: 'Odpowiedzialność własna',
    security_deposit: 'Depozyt zabezpieczający',
    fuel_policy: 'Polityka paliwowa',
    like_for_like: 'Tyle samo za tyle samo',
    full_to_full: 'Pełny do pełnego',
    miles_per_rental: '{mileage} darmowych mil na wynajem',
    km_per_rental: '{mileage} darmowych km na wynajem',
    unlimited_mileage: 'Nielimitowany przebieg',
    unlimited_mileage_km: 'Nielimitowane km',
    non_amendable: 'Nie można zmienić',
    non_refundable: 'Bezzwrotne',
    free_cancellation_until: 'Darmowe anulowanie do',
    basic_free_cancellation: 'Bezpłatne anulowanie do 48 godzin przed rozpoczęciem',
    cancellation_in_line_with: 'Anulowanie zgodnie z',
    tcs: 'Regulamin',
    free_extras_on_collection: 'Dwa darmowe dodatki przy odbiorze',
    glass_and_tyres_covered: 'Szyby i opony objęte ochroną',
    number_of_passengers: 'Liczba pasażerów',
    number_of_bags: 'Liczba bagaży',
    fuel_type: 'Rodzaj paliwa',
    co2: 'CO2',
    aircon: 'Klimatyzacja',
    transmission: 'Skrzynia biegów',
    book_type: 'Zarezerwuj {type}',
    debit_card_deposit: 'Akceptujemy karty debetowe na depozyt',
    fast_track_included: 'Szybka obsługa w cenie',
    view_all: 'Zobacz wszystko',
};
